module.exports = __webpack_public_path__ + "static/media/all-badges.c4ba66f1.png";